import getBasePath from '../functions/api-resource';
import empresa from '../functions/company';

const basePath = getBasePath('api', 'v1');

const CategoriaActions = {
    buscar: { method: 'GET', url: `${basePath}/tipos_producto?bySubstring={descripcion}&conexion=${empresa}` },

};

export default resource => resource(`${basePath}`, {}, CategoriaActions);


// WEBPACK FOOTER //
// ./src/common/resources/tipoProducto.js